import React, { useRef  } from "react";
import {
    Button
  } from 'react-bootstrap';
import { useLocation } from "react-router-dom";
import AuthService from '../services/AuthService';
import { useHistory } from 'react-router-dom';
import ReactToPrint from "react-to-print";

const Record = () => {
    let history = useHistory();
    const location = useLocation();
    const componentRef = useRef();
    const reloadPage = AuthService.reloadPage();
    if(typeof location.state === 'undefined'){
      history.push(reloadPage);
      window.location.reload();
    }
    const votes = location.state.votes;
    const ballotData = location.state.ballotData;
    const studentInfo = location.state.studentInfo;


/*   const onSubmit = (e) => {
    e.preventDefault();
  }; */

  class ComponentToPrint extends React.Component {
    render () {
        return (
          <>
            <table>
              <thead>
                <th>
                  <h1>{ballotData.electionName}</h1>
                </th>
              </thead>
              <tbody>
                <tr>
                  <td>This is a record of your votes</td>
                </tr>
                <tr>
                  <td>
                    Random ID: <b>{votes.UUID}</b>
                  </td>
                </tr>
                <tr>
                  <td>
                    We do not match this ID to any identifier, your vote is
                    anonymous.
                  </td>
                </tr>
                <tr>
                  <td>
                    This ID can be used to check the integrity of your vote
                  </td>
                </tr>
                <tr>
                  <td>
                    Print this page for your record. Your ID could not be looked
                    up after this page is closed
                  </td>
                </tr>
                <tr>
                  <td>
                    <br />
                  </td>
                </tr>
                {ballotData.allBallots.map((ballot) => {
                  if (
                    ballot.ballotRestrictionTypeId === 1 ||
                    (ballot.ballotRestrictionTypeId === 2 &&
                      studentInfo.classLevel ===
                        ballot.ballotRestrictionDetail) ||
                    (parseInt(ballot.ballotRestrictionTypeId) === 3 &&
                      studentInfo.classLevel !== 'G' &&
                      studentInfo.allColleges.some(
                        (college) =>
                          college.coll === ballot.ballotRestrictionDetail
                      )) ||
                    (ballot.ballotRestrictionTypeId === 4 &&
                      studentInfo.residential ===
                        ballot.ballotRestrictionDetail)
                  ) {
                    let elements = [];
                    let curVote = votes.allBallots.filter(
                      (x) => x.BallotId === ballot.ballotId
                    );
                    if (curVote) {
                      for (let i = 0; i < curVote.length; i++) {
                        if (curVote[i].WriteIn) {
                          elements.push(
                            <tr>
                              <td>{curVote[i].CandidateName} - Write In</td>
                            </tr>
                          );
                        } else {
                          let candidateName = ballot.allCandidates.find(
                            (c) =>
                              c.ballotCandidateId ===
                              curVote[i].BallotCandidateId
                          ).ballotCandidateName;
                          if (!ballot.referendum) {
                            let candidatePartyName = ballot.allCandidates.find(
                              (c) =>
                                c.ballotCandidateId ===
                                curVote[i].BallotCandidateId
                            ).ballotCandidatePartyName;
                            candidatePartyName =
                              candidatePartyName === ''
                                ? 'Independent'
                                : candidatePartyName;
                            elements.push(
                              <tr>
                                <td>
                                  {candidateName} - {candidatePartyName}
                                </td>
                              </tr>
                            );
                          } else {
                            elements.push(
                              <tr>
                                <td>{candidateName}</td>
                              </tr>
                            );
                          }
                        }
                      }
                    }
                    return (
                      <>
                        <tr>
                          <td>
                            <b>{ballot.ballotName}</b>
                          </td>
                        </tr>
                        {elements.length ? elements : '--Abstained--'}
                        <tr>
                          <td>
                            <br />
                          </td>
                        </tr>
                      </>
                    );
                  } else return false;
                })}
              </tbody>
            </table>
          </>
        );
    } 
  }

  return (ballotData ? (
    <>
    <ComponentToPrint ref={componentRef} />
      <hr />
      <ReactToPrint
          trigger={() => <Button
          bsStyle="primary"
          type='submit'>Print this out!</Button>}
          content={() => componentRef.current}
        />
            <hr />
      </>
    ) : 'Loading...'
  ); 
};
export default Record;